/**
 * @generated SignedSource<<34ecdbd77277520825702d358f682f25>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InterviewChatMessage_message",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "role",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    }
  ],
  "type": "OralInterviewMessage",
  "abstractKey": null
};

node.hash = "f30ee0a36fd998af13d9e9aee8ad1dae";

module.exports = node;
